<template>
	<div class="position">
		<div>
			<h3 class="popup-tilte">Jelszó visszaállító email elküldve!</h3>
			<div class="fs-desc popup-content-width">
				A jelszó visszaállításához szükséges e-mailt elküldtük, kérjük, ellenőrizze postafiókját és az e-mailben
				írtak szerint adja meg új jelszavát!
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>
